

export const HeroSection=()=>{
    
    return(
        <div className="hero-section">
            <div className="hero_img">
                <img src={require('../../../../static/hero-bg.jpg')}/>
            </div>
        </div>
    )
}